import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import svgHtaBg from '@img/general/hta-inner-bg-pattern.svg';
import { ReactComponent as SvgCalendar } from '@img/icons/date-icon.svg';
import { ReactComponent as SvgClock } from '@img/icons/time-icon.svg';
import { ReactComponent as SvgPin } from '@img/icons/location-icon.svg';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('accentColorAlt', brand.hta.greenLight)};
  ${setCssVar('bgColor', brand.hta.greenLight)};
  ${setCssVar('fgColor', brand.black)};

  display: flex;
  background: ${cssVar('bgColor')};

  padding: 32px 0;
  position: relative;

  /* HTA Shamrock Background */
  @media ${until(Device.Tablet)} {
    background-image: url('${svgHtaBg}'), url('${svgHtaBg}');
    background-repeat: repeat-x, repeat-x;
    background-position: bottom left, bottom 50px left 30px;
    background-size: 125px 50px;
  }

  /* HTA Shamrock Background */
  @media ${from(Device.TabletLarge)} {
    min-height: 380px;
    background-image: url('${svgHtaBg}'), url('${svgHtaBg}');
    background-repeat: repeat-x, repeat-x;
    background-position: bottom left, bottom 100px left 60px;
    background-size: 250px 100px;
  }
`;
const Inner = styled.div `
  position: relative;
  justify-content: center;

  display: grid;
  gap: 15px;
  grid-template-columns: repeat(12, 1fr);

  @media ${from(Device.Tablet)} {
    gap: 30px;
  }
`;
const BreadcrumbWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  color: ${brand.grey};
  transform: translateY(-10px);
`;
const ContentWrapper = styled.div `
  padding: 32px 0;
  grid-column: 2 / span 10;
  text-align: center;

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 12;
  }
`;
const Tag = styled.span `
  ${fonts.sourceSansPro.regular};
  color: ${brand.hta.greenDark};
  text-transform: uppercase;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 0.02em;

  @media ${until(Device.Tablet)} {
    font-size: 14px;
    line-height: 30px;
  }
`;
const Title = styled.h1 `
  ${HeadingStyles.H4Styles};
`;
const Base = styled.div `
  grid-column: 2 / span 10;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 12;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0;
  }
`;
const Date = styled.div `
  ${fonts.sourceSansPro.semiBold};
  font-size: 24px;
  line-height: 34px;
  display: flex;
  padding: 0 20px;
  align-items: center;

  @media ${until(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 15px;
  }
`;
const DateSvg = styled(SvgCalendar) `
  color: ${brand.black};
  width: 26px;
  height: 26px;
  margin-right: 10px;

  @media ${until(Device.TabletLarge)} {
    width: 19px;
    height: 19px;
  }
`;
const Time = styled.div `
  ${fonts.sourceSansPro.semiBold};
  font-size: 24px;
  line-height: 34px;
  display: flex;
  padding: 0 20px;
  align-items: center;

  @media ${until(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 15px;
  }
`;
const TimeSvg = styled(SvgClock) `
  color: ${brand.black};
  width: 24px;
  height: 24px;
  margin-right: 10px;

  @media ${until(Device.TabletLarge)} {
    width: 19px;
    height: 19px;
  }
`;
const Location = styled.div `
  ${fonts.sourceSansPro.semiBold};
  font-size: 24px;
  line-height: 34px;
  display: flex;
  align-items: center;
  padding: 0 20px;

  @media ${until(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 15px;
  }
`;
const LocationSvg = styled(SvgPin) `
  color: ${brand.black};
  width: 24px;
  margin-right: 10px;

  @media ${until(Device.TabletLarge)} {
    width: 19px;
  }
`;
export default {
    Base,
    BreadcrumbWrapper,
    Date,
    DateSvg,
    Container,
    ContentWrapper,
    Inner,
    Location,
    LocationSvg,
    Tag,
    Time,
    TimeSvg,
    Title,
};
